import { http } from '../../config/axios'

export default function getPromocaoVoucher(): Promise<any[]> {
  return http
    .get('api/voucher/promocao', { headers: { ignoreLoading: true } })
    .then((res) => res.data as any[])
    .catch((error) => {
      console.error('Erro getPromocaoVoucher', error)
      return [] as any[]
    })
}
